<template>
  <PolicyModal :show="show" title="Telehealth Consent Form" @close="$emit('close')">
    <p class="last-updated"><strong>Last Updated:</strong> January 1, 2025</p>

    <p>I understand that Telehealth is a mode of delivering health care services via communication technologies (e.g., internet or cellphone) to facilitate diagnosis, consultation, treatment, education, care management, and self-management of a patient's health care.</p>

    <p><strong>By acknowledging my consent below, I understand and agree to the following:</strong></p>
    <ul>
      <li>I understand that MD Integrations offers Telehealth consultations, which are conducted through videoconferencing, telephonic, and asynchronous technology and my Telehealth provider will not be present in the room with me.</li>
      <li>I understand there are potential risks to the use of Telehealth technology, including but not limited to, interruptions, delays, unauthorized access, and or other technical difficulties. I understand that either my Telehealth provider or I can discontinue the Telehealth appointment if the technical connections are not adequate for my visit.</li>
      <li>I understand that I could seek an in-office visit rather than obtain care from a Telehealth provider, and I am choosing to participate in a Telehealth consultation with MD Integrations provider.</li>
      <li>To protect the confidentiality of my health information, I agree to undertake my Telehealth consultation in a private location, and I understand that my Telehealth provider will similarly be in a private location.</li>
      <li>In an emergent situation, I understand that the responsibility of my Telehealth provider may be to direct me to emergency medical services, such as an emergency room.</li>
    </ul>

    <p><strong>By acknowledging below, I certify:</strong></p>
    <ul>
      <li>that I have read this form and/or had it explained to me</li>
      <li>that I understand the risks and benefits of a Telehealth appointment</li>
      <li>That I have been given the opportunity to ask questions and that such questions have been answered to my satisfaction.</li>
    </ul>

    <h2>CONSENT TO TEXT OR EMAIL USAGE FOR APPOINTMENT REMINDERS AND OTHER HEALTHCARE REMINDERS</h2>
    <p>By signing below, I consent to receive text messages from the practice at my phone number or email to receive appointment reminders and general health reminders of information. I understand that this request is to receive emails and/or text messages will apply to all future appointment reminders/feedback/health information unless I request a change in writing. I also acknowledge this means of communication is not considered secure for the transmission of private information.</p>
  </PolicyModal>
</template>

<script>
import PolicyModal from './PolicyModal.vue'

export default {
  name: 'TelehealthConsentContent',

  components: {
    PolicyModal
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
a {
  color: #08466f;
  text-decoration: underline;
}

a:hover {
  color: #063a5a;
}
</style>
